const fakeCompanies: any[] = [];

for (let index = 1; index <= 20; index++) {
  fakeCompanies.push({
    name: `COMPANY ${index}`,
  });
}

export default fakeCompanies;
